import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Component } from "react";
import { withRouter } from "react-router";

// Components
import MainLayout from "./MainLayout";

// Application Configurations
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

class MainLayoutContainer extends Component {
  // TODO: Store user id in login reducer
  // If user is unauthorized, redirect to login page
  checkForUnauthorizedUser = () => {
    if (
      !this.props.loginReducer.isCashier &&
      !this.props.loginReducer.userName
    ) {
      this.props.history.push(APPLICATION_CONFIGURATIONS.path.login);
    }
  };

  render() {
    return (
      <div>
        <MainLayout children={this.props.children} />
        {this.checkForUnauthorizedUser()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loginReducer: state.loginReducer,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(MainLayoutContainer)
);
